import request from '../utils/request'

//  配置
export function getConfig (params) {
    return request.post({url: '/config/getConfig', params})//: {atServ: 1}
}

export function getDictData (params) {
    return request.get({ url: '/setting.dict.dict_data/lists', params })
}

// 按分页取训练方案
export function getPlanData (params) {
    return request.get({ url: '/article.article/lists', params })
}

// 随机取一条训练方案
export function getRandPlanData (params) {
    return request.get({ url: '/user.evalua/getRandPlanData', params })
}

// 用户列表
export function getUserList (params) {
    return request.get({ url: '/user.user/lists', params }, { ignoreCancelToken: true })
}

export function getEvalualists (params) {
    return request.get({ url: '/user.evalua/lists', params })
}

// 用户添加
export function userAdd (params) {
    return request.post({ url: '/user.user/add', params })
}

// 用户详情
export function getUserDetail (params) {
    return request.get({ url: '/user.user/detail', params })
}

// 用户编辑
export function userEditMultiple (params) {
    return request.post({ url: '/user.user/editMultiple', params })
}

// 用户编辑
export function userEdit (params) {
    return request.post({ url: '/user.user/edit', params })
}

// 保存测评
export function saveEvalua (params) {
    return request.post({ url: '/user.evalua/saveEvalua', params })
}

// 提交完成测评
export function saveEvaluaFinish (params) {
    return request.post({ url: '/user.evalua/saveEvaluaFinish', params })
}

// 查看报告
export function viewReport (params) {
    return request.post({ url: '/user.evalua/viewReport', params })
}

// 测评参数
export function getEvaluaParams (params) {
    return request.post({ url: '/user.evalua/getEvaluaParams', params })
}

// 通过id取测评参数
export function getEvaluaRecordById (params) {
    return request.post({ url: '/user.evalua/getEvaluaRecordById', params })
}

// 保存测评带参数
export function saveEvaluaData (params) {
    return request.post({ url: '/user.evalua/saveEvaluaData', params })
}

// 取跟进记录列表
export function getFollowLogList (params) {
    return request.post({ url: '/user.follow/getFollowLogList', params })
}

// 保存跟进记录
export function saveFollowLog (params) {
    return request.post({ url: '/user.follow/saveFollowLog', params })
}

// 测评历史（按学员ID查询）
export function getEvaluaHistory (params) {
    return request.get({ url: '/user.evalua/evaluaHistory', params })
}

// 通过学生ID获取最新的evalua_number
export function getEvaluaNumberBySid (params) {
    return request.post({ url: '/user.user/getEvaluaNumberBySid', params })
}

//  解码
export function decodeCookie (str) {
    str = str + ''
    let strAry = str.split('a')
    let newstr = ''
    for (var i = 0; i < strAry.length; i++) {
        newstr += String.fromCharCode(parseInt(strAry[i]) - 1)
    }
    return newstr
}



// WEBPACK FOOTER //
// ./src/api/app.js